import { createFileRoute } from '@tanstack/react-router'

import { Workflows } from '@/widgets/workflows'

export const Route = createFileRoute('/_app/workflows/workflows/')({
  component: RouteComponent,
})

export const WorkflowRoute = Route

function RouteComponent() {
  return <Workflows />
}
